var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOfficeGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65039 4.34961H21.0004C21.2765 4.34961 21.5004 4.57347 21.5004 4.84961V18.7996C21.5004 19.0758 21.2765 19.2996 21.0004 19.2996H7.65039V4.34961Z",
    fill: "#9F9F9F",
    stroke: "#AAAAAA",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.7,
    height: 18.8,
    rx: 0.5,
    fill: "#B2B2B2",
    stroke: "#AAAAAA",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3496 15.6504H16.2496V19.5504H12.3496V15.6504Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6504 6.84961H18.4504V9.64961H15.6504V6.84961Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6504 11.25H18.4504V14.05H15.6504V11.25Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 6.84961H13.5002V9.64961H10.7002V6.84961Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 11.25H13.5002V14.05H10.7002V11.25Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4502 2.4502H5.2502V5.2502H2.4502V2.4502Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4502 6.2998H5.2502V9.0998H2.4502V6.2998Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4502 10.1504H5.2502V12.9504H2.4502V10.1504Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4502 14H5.2502V16.8H2.4502V14Z",
    fill: "#D2D2D2",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOfficeGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/office-grey.538889b08d6963b8a91fe6db3b56765f.svg";